export enum PosConnectionStatus {
  Connected = "CONNECTED",
  Pending = "PENDING",
  BadCredentials = "BAD_CREDENTIALS",
  Deleted = "DELETED",
}

export type PosCredentialFieldType = "string" | "password" | "number";

export type PosCredentialFieldDef = {
  key: string;
  label: string;
  type: PosCredentialFieldType;
  required: boolean;
  description?: string;
};

export type PosProviderInfo = {
  id: string;
  name: string;
  supportUrl?: string;
  connectionMethod?: string;
  credentialFields: PosCredentialFieldDef[];
};

export type PosConnection = {
  _id: string;
  posProvider: string;
  status: PosConnectionStatus;
  createdAt: string;
  updatedAt: string;
};
